import client from 'common/api/client';

export const postAggregationQuery = (query) => {
  const endpoint = '/aggregation';
  return client.post(endpoint, { ...query });
};
